// Validación algorítmica del codice fiscale italiano (formato + dígito de
// control), réplica EXACTA de CodiceFiscale del monolito
// (Getlife\Shared\Domain\Identity\CodiceFiscale), verificada carácter a carácter
// contra el PHP. Puro algoritmo (sin I/O): lo usa el funnel NATIVE para validar
// client-side, donde el endpoint /lead/identity/validate no aplica (en el build
// native pega al host del SPA → HTML → siempre inválido → botón bloqueado).

// Valores de las posiciones IMPARES (los pares son el dígito, o letra-65).
const CODICE_FISCALE_ODD: Record<string, number> = {
  "0": 1, "1": 0, "2": 5, "3": 7, "4": 9, "5": 13, "6": 15, "7": 17, "8": 19, "9": 21,
  A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21, K: 2, L: 4, M: 18,
  N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};

export const isValidCodiceFiscale = (raw: string): boolean => {
  const value = (raw || "").toUpperCase();
  if (!/^[A-Z0-9]{16}$/.test(value)) {
    return false;
  }
  const modified = `0${value}`; // índice 0..16; el control es modified[16] = value[15]
  let sum = 0;
  for (let i = 1; i < 16; i++) {
    const ch = modified.charAt(i);
    if (i % 2 === 0) {
      sum += /[0-9]/.test(ch) ? parseInt(ch, 10) : ch.charCodeAt(0) - 65;
    } else {
      if (!(ch in CODICE_FISCALE_ODD)) {
        return false;
      }
      sum += CODICE_FISCALE_ODD[ch];
    }
  }
  return String.fromCharCode(65 + (sum % 26)) === modified.charAt(16);
};
